// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_Vu3","placeholdersHeader":"styles_placeholdersHeader__2ToWH","editorStyle":"styles_editorStyle__1rBuL","placeholdersBox":"styles_placeholdersBox__1ZPBP"};